<section class="show-cookies">


  <section>
    <section *ngIf = "pageToShow == '1'" id = "screen1">
      <div  class="flex ">
        <div class="left-bar d-none d-sm-block">
          <div class="logo-contain flex pad-top-30 pad-bot-30 justify-center">
            <img class="img-fluid" src = "https://images.poshvine.com/logos/mastercard_logo.png" alt = "">
          </div>
          <div class="menu-item fnt-16 f500 flex align-center pad-left-20 active">Your privacy</div>
          <div class="menu-item fnt-16 f500 flex align-center pad-left-20">Strictly necessary cookies</div>
        </div>
        <div class="right-bar relative pad-left-30 pad-top-45">
          <div class="absolute pointer modal-close-svg" >
            <svg (click)="hideModal()" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z" fill="#919aa2" />
            </svg>
          </div>
          <div class="t1">
            <img class="d-block d-sm-none img-fluid" src = "https://images.poshvine.com/logos/mastercard_logo.png" alt = "">
            <div class="f500 fnt-28 main-title">Cookies on the site</div>
          </div>
          <div class="mar-top-50 info-sec">
            <div class="sub-title f500 fnt-18 mar-bot-22">Your privacy</div>
            <div class="info fnt-14 mar-bot-30">
              <p>Our site uses cookies and other similar technologies like pixel tags and web beacons. A cookie is a small piece of data that a website asks your browser to store on your computer or mobile device. Cookies allow a site to "remember" your actions or preferences over time. So when you visit our site, the cookies may store or retrieve information on your browser, which may be about you, your preferences and/or your device. We use cookies, as well as third party cookies, to operate and improve the site, measure our audience, enhance your experience and provide you with content and advertising tailored to your interests based on your browsing activities and actions on this and other sites. For instance, cookies enable us to assess how many users access or use our service, which content, products, and features of our service most interest our users, what types of content our users like to see, and how our service performs from a technical point of view.</p>
              <p>Click on the different category headings to manage your cookie preferences and find out more about the cookies we use and why. Click on Allow All if you want all cookies enabled (although essential cookies are always enabled).</p>
            </div>
          </div>
        </div>
      </div>
      <section class="bottom-sec flex">
        <button class="btn brand-btn f500 fnt-16">Save Setting</button>
      </section>
    </section>
    <section *ngIf = "pageToShow == '2'" id = "screen2">
      <div  class="basic-container">
        <div class="logo-contain basic-logo flex pad-top-30 pad-bot-30">
          <img class="img-fluid" src = "https://images.poshvine.com/logos/mastercard_logo.png" alt = "">
        </div>
        <div>
          <div i18n class="sub-title f500 fnt-18 mar-bot-22">We respect your privacy</div>
          <div class="info fnt-14 mar-bot-30">
            <p i18n>Our site uses cookies and other similar technologies like pixel tags and web beacons. A cookie is a small piece of data that a website asks your browser to store on your computer or mobile device. Cookies allow a site to "remember" your actions or preferences over time. So when you visit our site, the cookies may store or retrieve information on your browser, which may be about you, your preferences and/or your device. </p>
          </div>
        </div>
        <div>
          <button i18n class="btn trans-btn mar-bot-15" id="accept-cookie" (click) = "acceptCookies(true)">Accept Cookies</button>
          <!-- <button class="btn trans-btn mar-top-15 mar-bot-15" (click) = "acceptCookies(false)">Reject All</button> -->
        </div>
      </div>
      <section class="bottom-sec flex">
        <button i18n class="btn brand-btn f500 fnt-16" (click) = "pageToShow = '3'">Manage your cookie preference</button>
      </section>
    </section>
    <section *ngIf = "pageToShow == '3'" id = "screen3">
      <div class="basic-container">
        <div (click) = "pageToShow = '2'" class="flex pad-top-30 pad-bot-22 align-center">
          <div class="flex align-center pointer">
            <svg class="mar-right-8 mar-bot-1" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 6.125H3.35125L8.2425 1.23375L7 0L0 7L7 14L8.23375 12.7663L3.35125 7.875H14V6.125Z" fill="#172733"/>
            </svg>
            <span i18n class="fnt-12">Back</span>
          </div>

        </div>
        <h4 i18n class="sub-title f500 fnt-18 mar-bot-22">Manage your cookie preference</h4>
        <div class="cookie-types mar-bot-40">
          <accordion [isAnimated]="true">
            <accordion-group>
              <div class="flex align-center space-between acc-head pad-left-20 pad-right-20" accordion-heading>
                <div class="flex left-part">
                  <span class="fnt-28 plus-ic mar-top-3">+</span>
                  <span class="fnt-28 minus-ic mar-top-3">-</span>
                  <span i18n class="mar-left-10 fnt-15 f500 txt">Strictly necessary cookies</span>
                </div>
                <span i18n class="c-tag pad-top-4 pad-bot-4 fnt-13 flex align-center justify-center">Always Active</span>
              </div>
              <div class="tab-details fnt-14" i18n>Our site uses cookies and other similar technologies like pixel tags and web beacons. A cookie is a small piece of data that a website asks your browser to store on your computer or mobile device. Cookies allow a site to your actions or preferences over time.</div>
            </accordion-group>



          </accordion>
        </div>
      </div>
      <section class="bottom-sec flex">
        <button i18n class="btn brand-btn f500 fnt-16" (click) = "acceptCookies(true)">Confirm my Choices</button>
      </section>
    </section>

  </section>


</section>
